<template>
  <v-card class="card-container">
    <div class="main-toolbar mb-4">
      <div class="icon-back">
        <v-icon color="white" size="28">mdi-lightning-bolt-outline</v-icon>
      </div>

      <span class="main-toolbar-title"> Segurança Elétrica </span>
    </div>

    <div class="hidden-md-and-up">
      <v-tabs
        :height="40"
        :mobile-break-point="300"
        v-model="tab"
        class="ma-auto"
        icons-and-text
        touchless
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-on="on"
              v-bind="attrs"
              href="#tabCertified"
            >
              <v-icon>mdi-decagram</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Certificados') }}</span>
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-tab
              active-class="activated-tab"
              class="rounded-lg rounded-b-0"
              v-on="on"
              v-bind="attrs"
              href="#tabPattern"
            >
              <v-icon>mdi-cog</v-icon>
            </v-tab>
          </template>
          <span>{{ $t('Padrão') }}</span>
        </v-tooltip>
      </v-tabs>
    </div>

    <div class="hidden-sm-and-down">
      <v-tabs
        :height="40"
        :mobile-break-point="360"
        v-model="tab"
        class="ma-0"
        icons-and-text
        touchless
      >
        <v-tabs-slider color="#BBCF20"></v-tabs-slider>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          href="#tabCertified"
        >
          {{ $t('Certificados') }}
          <v-icon class="mt-1 mr-2">mdi-decagram</v-icon>
        </v-tab>
        <v-tab
          active-class="activated-tab"
          class="rounded-lg rounded-b-0"
          href="#tabPattern"
        >
          {{ $t('Padrão') }}
          <v-icon class="mt-1 mr-2">mdi-cog</v-icon>
        </v-tab>
      </v-tabs>
    </div>
    <v-tabs-items v-model="tab" touchless>
      <v-tab-item value="tabCertified">
        <v-card flat class="mt-0">
          <CertifiedTab />
        </v-card>
      </v-tab-item>
      <v-tab-item value="tabPattern">
        <v-card flat class="mt-0">
          <PatternTab />
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import CertifiedTab from './components/CertifiedTab.vue'
import PatternTab from './components/PatternTab.vue'

export default {
  name: 'EletricalSafety',

  components: {
    CertifiedTab,
    PatternTab,
  },

  created() {
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab
    }
  },

  data() {
    return {
      tab: null,
    }
  },
}
</script>

<style scoped>
.v-tabs--icons-and-text > .v-tabs-bar .v-tab {
  flex-direction: row-reverse;
}

.v-tab.v-tab {
  color: #bbcf20;
}

.v-tab {
  text-transform: none;
}

.v-tab--active {
  background-color: #e7eaeb;
}
</style>
